import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslocoUtils } from '@aodocs/shared-translation';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'aodocs-microsoft-sign-in',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  providers: [
    provideTranslocoScope({
      scope: 'authentication',
      loader: TranslocoUtils.loader((lang) => import(`../../../assets/i18n/lib/authentication/authentication-${lang}.json`)),
    }),
  ],
  templateUrl: './microsoft-sign-in.component.html',
  styleUrls: ['./microsoft-sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MicrosoftSignInComponent {
  @Output() clickEvent = new EventEmitter<void>();
}
